import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { ApiHttpError } from '@atlas/sdk';
import { Button, Modal, NumberField, TextareaField, FormActions } from '@atlas/ui/web';
import { atlas } from '../lib/sdk';

export function CronogramaLegadoModal({ adf, nome, totalParcelas, parcelasPagas, papel, onClose, onSalvo }: {
  adf: string; nome: string; totalParcelas: number; parcelasPagas: number;
  papel: 'banco' | 'averbadora'; onClose: () => void; onSalvo: () => void;
}) {
  const [total, setTotal] = useState(totalParcelas > 0 ? String(totalParcelas) : '');
  const [pagas, setPagas] = useState(String(parcelasPagas));
  const [motivo, setMotivo] = useState('');
  const [erro, setErro] = useState('');
  const mut = useMutation({
    mutationFn: () => {
      if (!total || !pagas || !Number.isInteger(Number(total)) || !Number.isInteger(Number(pagas)) || Number(total) <= 0 || Number(pagas) < parcelasPagas || Number(pagas) > Number(total)) throw new Error('Informe o prazo e as parcelas pagas. A correção não pode apagar parcelas confirmadas.');
      const body = { totalParcelas: Number(total), parcelasPagas: Number(pagas), motivo: motivo.trim() };
      return papel === 'banco' ? atlas.banco.informarCronogramaLegado(adf, body) : atlas.admin.informarCronogramaLegado(adf, body);
    },
    onSuccess: () => { onSalvo(); onClose(); },
    onError: (e) => {
      if (e instanceof ApiHttpError && e.details && typeof e.details === 'object') {
        const mensagens = Object.values(e.details).filter((v): v is string => typeof v === 'string');
        setErro(mensagens.length ? mensagens.join(' ') : e.message);
      } else setErro(e instanceof Error ? e.message : 'Falha ao gravar o cronograma.');
    },
  });
  return <Modal open onClose={() => { if (!mut.isPending) onClose(); }} title={totalParcelas > 0 ? 'Corrigir cronograma' : 'Completar cronograma'} subtitle={`${nome} · ADF ${adf}`}>
    <form onSubmit={(e) => { e.preventDefault(); setErro(''); mut.mutate(); }} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <p style={{ margin: 0 }}>A falta do prazo não encerra o contrato. Informe os dados confirmados da carteira. A alteração fica registrada no histórico.</p>
      <NumberField label="Total de parcelas" min="1" max="999" required value={total} onChange={(e) => setTotal(e.target.value)} />
      <NumberField label="Parcelas já pagas" min={parcelasPagas} max={total || undefined} required value={pagas} onChange={(e) => setPagas(e.target.value)} />
      <TextareaField label="Fonte e motivo da correção" required minLength={10} maxLength={500} value={motivo} onChange={(e) => setMotivo(e.target.value)} placeholder="Ex.: carteira oficial enviada pela consignatária" />
      {total && pagas && Number(pagas) === Number(total) ? <p>As parcelas informadas indicam quitação. Confira os dados antes de salvar.</p> : null}
      {erro ? <p role="alert">{erro}</p> : null}
      <FormActions><Button type="button" disabled={mut.isPending} onClick={onClose}>Cancelar</Button><Button type="submit" disabled={mut.isPending}>{mut.isPending ? 'Salvando…' : 'Salvar cronograma'}</Button></FormActions>
    </form>
  </Modal>;
}
